import styled from "styled-components";
import { theme } from "../../../config";

export const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  background: ${theme.colors.custom.background};
  padding: 57px 83px 40px 83px;
  @media ${theme.breakpoints.mobileAndTablet} {
    padding: 25px 0 15px 16px;
  }
  overflow: auto;
`;

export const Header = styled.header`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  z-index: 1;
  background: ${theme.colors.custom.background};
  margin-top: -28px;
  position: sticky;
  top: -65px;
  padding-top: 30px;
`;

export const BackIcon = styled.img`
  margin-top: 12px;
  margin-right: 15px;
  cursor: pointer;
  height: 21px;
`;

export const LeftSideWrapper = styled.div`
  display: flex;
`;

export const RightSideWrapper = styled.div``;

export const HeaderText = styled.h1`
  font-family: Orkney Bold;
  font-size: 34px;
  line-height: 48px;
  margin-bottom: 1em;

  @media ${theme.breakpoints.mobileAndTablet} {
    font-size: 22px;
    line-height: 26px;
  }
`;

export const FormWrapper =  styled.div`
  background: ${theme.colors.white};
  padding: 0 0 25px;
  border-radius: 8px;
  display: block;
  min-height: 700px;
  ${theme.defaultBoxShadow}
`;